<script>
import Glide from '@glidejs/glide'


export default {
    data() {
        return {
            glide: null
        }
    },
    mounted() {
        this.glide = new Glide(this.$el, {
            type: 'carousel',
            autoplay: 5000,
            animationDuration: 1400,
            rewindDuration: 1400
        }).mount()
    }
}
</script>

<template>
    <div class="glide mb-4">
        <div class="glide__track" data-glide-el="track">
            <ul class="glide__slides">
                <slot>

                </slot>
            </ul>
        </div>
        <div data-glide-el="controls">
            <button data-glide-dir="<" class="btn btn-white">Prev</button>
            <button data-glide-dir=">" class="btn btn-white">Next</button>
        </div>
    </div>
</template>
